export default "__VITE_ASSET__BJFhyKFp__"